import { ImageProps } from '@components/image';
import React from 'react';
import { Container, LinkButton, StyledImage } from './download-buttons.styled';

export interface ItemAppDownload {
  icon?: ImageProps;
  title?: {
    text: string;
  };
  link_label?: string;
  link?: {
    url?: string;
  };
}

interface DownloadButtonsProps {
  items?: ItemAppDownload[];
}

const DownloadButtons = ({ items }: DownloadButtonsProps): JSX.Element => (
  <Container>
    {items?.map(({ icon, link_label, link }) => (
      <LinkButton href={link?.url} key={link?.url} aria-label={link_label}>
        <StyledImage url={icon?.url} alt={icon?.alt} />
      </LinkButton>
    ))}
  </Container>
);

export default DownloadButtons;
